/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { ClientPortal, ClientPortalUser } from '../../data/types';
import { RootState } from '../configureStore';

export type ClientPortalState = {
    portals: ClientPortal[];
    users: ClientPortalUser[];
};

export const useClientPortalState = () => {
    return useSelector((state: RootState | any) => state.clientPortal as ClientPortalState);
};

const initialState: ClientPortalState = {
    portals: [],
    users: [],
};

export const clientPortalSlice = createSlice({
    name: 'clientPortal',
    initialState,
    reducers: {
        setClientPortalsAction: (state, action: PayloadAction<ClientPortal[]>) => {
            state.portals = action.payload;
        },
        addOrReplaceClientPortalAction: (state, action: PayloadAction<ClientPortal>) => {
            const portal = action.payload;
            const existingIndex = state.portals.findIndex(
                (existingPortal) => !!portal.portalId && existingPortal.portalId === portal.portalId,
            );

            if (existingIndex >= 0) {
                state.portals[existingIndex] = portal;
            } else {
                state.portals.push(portal);
            }
        },
        removeClientPortalAction: (state, action: PayloadAction<string>) => {
            state.portals = state.portals.filter((portal) => portal.portalId !== action.payload);
        },
        setClientPortalUsersAction: (state, action: PayloadAction<ClientPortalUser[]>) => {
            state.users = action.payload;
        },
        addOrReplaceClientPortalUserAction: (state, action: PayloadAction<ClientPortalUser>) => {
            const user = action.payload;
            const existingIndex = state.users.findIndex(
                (existingUser) =>
                    existingUser.portalId === user.portalId
                    && (
                        (!!user.userId && existingUser.userId === user.userId)
                        || (!!user.username && existingUser.username === user.username)
                    ),
            );

            if (existingIndex >= 0) {
                state.users[existingIndex] = user;
            } else {
                state.users.push(user);
            }
        },
        removeClientPortalUserAction: (state, action: PayloadAction<string>) => {
            state.users = state.users.filter(
                (user) => user.userId !== action.payload && user.username !== action.payload,
            );
        },
        clearClientPortalAction: (state) => {
            state.portals = [];
            state.users = [];
        },
    },
});

export const {
    addOrReplaceClientPortalAction,
    addOrReplaceClientPortalUserAction,
    clearClientPortalAction,
    removeClientPortalAction,
    removeClientPortalUserAction,
    setClientPortalsAction,
    setClientPortalUsersAction,
} = clientPortalSlice.actions;

export default clientPortalSlice.reducer;
